import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import Button from "../../shared/button/Btn";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { showModal } from "../../../features/modal/modalSlice";
import { useScrollLock } from "../../../hooks/useScrollLock";
import PageTopTitle from "../../shared/PageTopTitle";
import { adminGetTrailerDoc, adminGetTruckDoc } from "../../../features/admin2/admin2Slice";

const Container = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;

  .modal {
    width: 550px;
    height: auto;
    color: ${({ theme }) => theme.mainTextColor};
    background-color: ${({ theme }) => theme.mainBgColor};
    border-radius: 10px;
    padding-block: 20px;
    overflow: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .content {
      padding: 20px;
      .col{
        width: 80%;
        margin: 0 auto;
        margin-block: 25px;
        .row{
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-block: 15px;
            p{
                font-size: var(--font-size-md);
                font-weight: var(--font-weight-md);
            }
            span{
                font-size: var(--font-size-md);
                font-weight: var(--font-weight-sm);
            }
        }
      }
    }
    .btn {
      padding-inline: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      button {
        margin-inline: 10px;
      }
    }
  }
`;

const KooperatifAracDetayModal = () => {
  const { modalLocation } = useSelector((state) => state.modal);
  const { selectAdminArac } = useSelector((state) => state.admin2);
  const dispatch = useDispatch();
  const location = useLocation();
  const { lockScroll, unlockScroll } = useScrollLock();

  // //! bu modal açıldığnda ekran ı lock lamak için
  useEffect(() => {
    lockScroll();

    return () => {
      unlockScroll();
    };
  }, [lockScroll, unlockScroll]);

  // //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
  useEffect(() => {
    if (location.pathname !== modalLocation) {
      dispatch(showModal(null));
    }
  }, [dispatch, location.pathname, modalLocation]);

  return (
    <Container onClick={() => dispatch(showModal(null))}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <PageTopTitle title={"Araç Ekle"} />
        <div className="content">
            
            <div className="col">
                <div className="row">
                    <p>Ad Soyad:</p>  
                    <span>{selectAdminArac?.adSoyadUnvan || "-"}</span>
                </div>
                <div className="row">
                    <p>Telefon Numarası:</p>  
                    <span>{selectAdminArac?.phoneNumber || "-"}</span>
                </div>
                <div className="row">
                    <p>Plaka: </p>
                    <span>{selectAdminArac?.truckPlateNumber || "-"}</span>
                </div>
                <div className="row">
                    <p>Araç Türü: </p>
                    <span>{selectAdminArac?.truckType === "Römork" || selectAdminArac?.truckType === "Y.Römork"
                    ? selectAdminArac?.trailerType
                    : selectAdminArac?.truckSubType}
                    </span>
                </div>
                <div className="row">
                    <p>Araç Tipi: </p>
                    <span>{selectAdminArac?.truckType === null ? selectAdminArac?.trailerType : selectAdminArac?.truckType}</span>
                </div>
                <div className="row">
                    <p>Kasa Tipi: </p>
                    <span>{selectAdminArac?.truckType === "Römork" || selectAdminArac?.truckType === "Y.Römork"
                    ? selectAdminArac?.trailerSubType
                    : selectAdminArac?.trailerType}
                    </span>
                </div>
                {/* <div className="row">
                    <p>Zemin Tipi: </p>
                    <span>{selectAdminArac?.groundType || "-"}</span>
                </div> */}
                <div className="row">
                    <p>Araç Markası: </p>
                    <span>{selectAdminArac?.truckBrand || "-"}</span>
                </div>
                <div className="row">
                    <p>Araç Modeli: </p>
                    <span>{selectAdminArac?.truckModel || "-"}</span>
                </div> 
                <div className="row">
                    <p>Araç Model Yılı: </p>
                    <span>{selectAdminArac?.truckModelYear || "-"}</span>
                </div> 
                <div className="row">
                    <p>Trafik Sigortası Geçerlilik Tarihi: </p>
                    <span>{selectAdminArac?.trafikSigortasıGecerlilikTarihi || "-"}</span>
                </div> 
                <div className="row">
                    <p>Muayene Geçerlilik Tarihi: </p>
                    <span>{selectAdminArac?.muayeneGecerlilikTarihi || "-"}</span>
                </div> 
                <div className="row">
                    <p>Kasko Geçerlilik Tarihi: </p>
                    <span>{selectAdminArac?.kaskoGecerlilikTarihi || "-"}</span>
                </div> 
            </div>
            
        </div>
        <div className="btn">
            <Button width="120px" handleClick={() => {
                dispatch( (selectAdminArac?.truckType === "Y.Römork" || selectAdminArac?.truckType === "Römork")
                ? adminGetTrailerDoc(selectAdminArac?.truckPlateNumber)
                : adminGetTruckDoc(selectAdminArac?.truckPlateNumber)
                );

                dispatch((selectAdminArac?.truckType === "Y.Römork" || selectAdminArac?.truckType === "Römork")
                ? showModal("kooperatifDorseBelgeIslemler")
                : showModal("kooperatifAraclarBelgeIslemler")
                )
                }} padding="10px" bgColor="transparent" color={"#E85446"}>
                Araç Belgeleri
            </Button>
            <Button width="120px" handleClick={() => dispatch(showModal("kooperatifAracGuncelle"))} padding="10px" bgColor="transparent" color={"#E85446"}>
                Araç Güncelle
            </Button>
            <Button width="120px" handleClick={() => dispatch(showModal(null))} padding="10px" bgColor="#E85446" color={"#fff"}>
                Kapat
            </Button>
        </div>
      </div>
    </Container>
  );
};

export default KooperatifAracDetayModal;
